import PropTypes from 'prop-types'
import React from 'react'
import styles from './_statsSummary.css'
import { FormattedDistance } from 'shared/units'
import { FormattedDuration } from 'shared/units'
import { FormattedEnergy } from 'shared/units'
import { LONG } from 'shared/units/constants'
import Svg from 'components/util/Svg'
import { FormattedMessage } from 'react-intl'

export default function StatsSummary ({ totals }) {
  return (
    <section className={styles.summary}>
      <div className={styles.summaryItem}>
        <div className={styles.lifetimeStatsIconContainer}>
          <Svg className={styles.lifetimeStatsIcon} name='stat_distance' />
        </div>
        <div className={styles.summaryTitle}>
          <FormattedMessage id='statssummary.distance' defaultMessage='Distance' />
        </div>
        <div>
          <span className={styles.summaryAmount}>
            <FormattedDistance value={totals.distance} digits={2} />
          </span>
        </div>
      </div>
      <div className={styles.summaryItem}>
        <div className={styles.lifetimeStatsIconContainer}>
          <Svg className={styles.lifetimeStatsIcon} name='stat_duration' />
        </div>
        <div className={styles.summaryTitle}>
          <FormattedMessage id='statssummary.duration' defaultMessage='Duration' />
        </div>
        <div>
          <span className={styles.summaryAmount}>
            <FormattedDuration value={totals.duration} digits={2} unit={LONG} />
          </span>
        </div>
      </div>
      <div className={styles.summaryItem}>
        <div className={styles.lifetimeStatsIconContainer}>
          <Svg className={styles.lifetimeStatsIcon} name='stat_workouts' />
        </div>
        <div className={styles.summaryTitle}>
          <FormattedMessage id='statssummary.workouts' defaultMessage='Workouts' />
        </div>
        <span className={styles.summaryAmount}>
          <div data-value>{totals.activity_count}</div>
        </span>
      </div>
      <div className={styles.summaryItem}>
        <div className={styles.lifetimeStatsIconContainer}>
          <Svg className={styles.lifetimeStatsIcon} name='stat_calories' />
        </div>
        <div className={styles.summaryTitle}>
          <FormattedMessage id='statssummary.energy' defaultMessage='Energy' />
        </div>
        <div>
          <span className={styles.summaryAmount}>
            <FormattedEnergy from='joules' value={totals.energy} digits={0} />
          </span>
          <span className={styles.summaryTag}>
            <FormattedMessage id='statssummary.burned' defaultMessage='burned' />
          </span>
        </div>
      </div>
    </section>
  )
}

StatsSummary.propTypes = {
  totals: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/workouts/dashboard/lifetime/StatsSummary.jsx